import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { wxCopilotContextManager } from 'utils/wxCopilotContextManager';

export function useWxCopilotPageContext(mountId = 'wx-copilot-root') {
  const location = useLocation();

  useEffect(() => {
    if (!mountId) return;
    const url = `${location.pathname}${location.search}${location.hash}`;
    wxCopilotContextManager.sendPageContext(url, mountId);
  }, [location, mountId]);

  useEffect(
    () => () => {
      wxCopilotContextManager.cleanup();
    },
    [],
  );
}
